import { render, staticRenderFns } from "./search-page-component.vue?vue&type=template&id=933bb6fa&scoped=true&"
import script from "./search-page-component.vue?vue&type=script&lang=ts&"
export * from "./search-page-component.vue?vue&type=script&lang=ts&"
import style0 from "./search-page-component.vue?vue&type=style&index=0&id=933bb6fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "933bb6fa",
  null
  
)

export default component.exports